import { Directive } from '@angular/core';

@Directive({
  selector: '[appSchedulerItemOnList]',
  standalone: true,
})
export class SchedulerItemOnListDirective {
  constructor() {}
}

@Directive({
  selector: '[appSchedulerMenu]',
  standalone: true,
})
export class SchedulerMenuDirective {
  constructor() {}
}

@Directive({
  selector: '[appSchedulerSubtitle]',
  standalone: true,
})
export class SchedulerSubtitleDirective {
  constructor() {}
}
